import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

const Pagination = ({
  changeDetail, currentDetailIndex, invoicesLength, isFirstDetail, isLastDetail
}) => {
  return currentDetailIndex >= 0 &&
        <div className="pre-cog-detail-header-change-detail">
          <div style={{display: "flex"}}>
            <div style={{color: "#0090d1", paddingRight: 6}}>{currentDetailIndex+1}</div> di {invoicesLength}
          </div>
          {!isFirstDetail &&
            <FontAwesomeIcon icon={["far", "arrow-circle-left"]} className="pre-cog-detail-header-change-arrow" onClick={() => changeDetail(-1)} />
          }
          {!isLastDetail &&
            <FontAwesomeIcon icon={["far", "arrow-circle-right"]} className="pre-cog-detail-header-change-arrow" onClick={() => changeDetail(1)} />
          }
        </div>;
  
};

export default Pagination;